export const ResearchMetricCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
  {
    name: 'Ricerca Metrica',
    path: '/pratiche/ricerca-metrica',
  },
];

export const NewMetricCrubs = [
  ...ResearchMetricCrubs,
  {
    name: 'Nuova Metrica',
    path: '/pratiche/ricerca-metrica/nuovo',
  },
];

export const EditMetricCrubs = [
  ...ResearchMetricCrubs,
  {
    name: 'Modifica Metrica',
    path: '/pratiche/ricerca-metrica/modifica',
  },
];

export const DetailMetricCrubs = [
  ...ResearchMetricCrubs,
  {
    name: 'Dettaglio Metrica',
    path: '/pratiche/ricerca-metrica/dettaglio',
  },
];
